export default (readOnly = false) => ({
  UPPERCASE: {
    textTransform: 'uppercase',
  },
  readOnly,
});
